/**
 * Environments of K-Management (docs/adr/ADR-003): every change reaches `test`
 * first, from the develop branch, and `production` only after validation, from
 * main. `development` is a developer's machine.
 */
export const APP_ENVIRONMENTS = ['development', 'test', 'production'];
export const ENVIRONMENT_LABELS = {
    development: 'Sviluppo',
    test: 'Test',
    production: 'Produzione',
};
export function isAppEnvironment(value) {
    return APP_ENVIRONMENTS.includes(value);
}
//# sourceMappingURL=environments.js.map